import { MyleTableColumn } from "@/Common/Components/Tables/MyleTableColumn";
import { PortfolioSentFaxSortOrderType, SortDirection } from "@/Common/Models/UI/Enums";
import { MyleTableTarget } from "@/Common/Models/UI/Tables/MyleTableTarget";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BaseOperationHandler } from "@/Common/Stores/Handlers/Local/BaseOperationHandler";
import { SentFaxInboxItem } from "@/Portfolio/Models/MyNotesInboxItem";
import { PortfolioStore } from "@/Portfolio/Stores/PortfolioStore";

class SentFaxInboxHandler extends BaseOperationHandler {
    private faxDebounceTimeoutReference: number;

    constructor() {
        super();
        this.RegisterOperation(LocalOperations.Portfolio.MySentFaxes_SearchBoxTextChanged, this.searchTextChanged);
        this.RegisterOperation(LocalOperations.Portfolio.MySentFaxes_Search_CurrentPageChange, this.resultsPageChange);
        this.RegisterOperation(LocalOperations.Portfolio.MySentFaxes_SearchSettings_OnResultsPerPageChange, this.resultsPerPageChange);
        this.RegisterOperation(LocalOperations.Portfolio.MySentFaxes_ToggleFailedVisibility, this.toggleFailedVisibility);
        this.RegisterOperation(LocalOperations.Misc.Table_ColumnSortClick, this.setColumnSort);
        this.RegisterOperation(LocalOperations.Portfolio.MySentFaxes_OpenFaxPreview, this.openFaxPreview);
    }

    private toggleFailedVisibility(request: LocalEvent, store: PortfolioStore): void {
        let data = request.Get<SentFaxInboxItem>("SentFaxItem");
        store.PortfolioActions.ToggleFailedFaxVisibility(data.ItemId, data.SentFaxId, data.FailCounterVisibility);
    }

    private setColumnSort(request: LocalEvent, store: PortfolioStore): void {
        let tableTarget = request.Get<MyleTableTarget>("target");
        let model = store.getActiveFaxModel();

        if (tableTarget === MyleTableTarget.Myle_PortfolioMySentFaxes_Search_ColumnSortClick) {
            let columnOrderType = request.Get<PortfolioSentFaxSortOrderType>("sortColumn");

            if (model.get("OrderByColumn") && model.get("OrderByColumn") === columnOrderType) {
                if (model.get("OrderByDirection") === SortDirection.ASC)
                    model = model.set("OrderByDirection", SortDirection.DESC);
                else
                    model = model.set("OrderByDirection", SortDirection.ASC);
            }
            else {
                model = model.set("OrderByColumn", columnOrderType);
                model = model.set("OrderByDirection", SortDirection.ASC);
            }

            let column = request.Get<MyleTableColumn>("columnObject");

            if (column) {
                if (column.columnOptions.IsSortActive) {
                    column.ToggleSortDirection();
                }
                column.columnOptions.IsSortActive = true;
            }

            store.PortfolioActions.LoadPortfolioFaxes(model);
        }
        store.setActiveFaxModel(model);
    }

    private resultsPageChange(request: LocalEvent, store: PortfolioStore): void {
        let value = request.Get<number>("Page");
        let model = store.getActiveFaxModel();
        model = model
            .set("SelectedPageNumber", value)
            .set("CurrentPage", value);
        store.setActiveFaxModel(model);

        clearTimeout(this.faxDebounceTimeoutReference);
        this.faxDebounceTimeoutReference = window.setTimeout(() => {
            store.PortfolioActions.LoadPortfolioFaxes(model);
        }, 250);
    }

    private resultsPerPageChange(request: LocalEvent, store: PortfolioStore): void {
        let model = store
            .getActiveFaxModel()
            .set("SelectedPageNumber", 1)
            .set("SelectedPageSizeOption", request.Get<number>("value"));

        store.setActiveFaxModel(model);
    }

    private searchTextChanged(request: LocalEvent, store: PortfolioStore): void {
        let model = store.getActiveFaxModel();
        model = model.set("SelectedPageNumber", 1);
        model = model.set("GlobalPortfolioSearchText", request.Get<string>("value"));
        store.PortfolioActions.LoadPortfolioFaxes(model);
        store.setActiveFaxModel(model);
    }

    private openFaxPreview(request: LocalEvent, store: PortfolioStore): void {
        let sentFaxItem = request.Get<SentFaxInboxItem>("rowData");
        let withSignature = request.Get<boolean>("withSignature") || false;

        let model = store.getActiveFaxModel()
            .set("SentFaxPDF", null)
            .set("SelectedSentFaxInboxItem", null);
        store.setActiveFaxModel(model);

        store.PortfolioActions.GetSentFaxPreview(sentFaxItem, withSignature);
    }
}

export { SentFaxInboxHandler };
